import SuccessorPage from './SuccessorPage';

export default SuccessorPage;